import React from "react";
import Box from "@mui/joy/Box";
import Drawer from "@mui/joy/Drawer";
import Button from "@mui/joy/Button";
import List from "@mui/joy/List";
import Divider from "@mui/joy/Divider";
import ListItem from "@mui/joy/ListItem";
import ListItemButton from "@mui/joy/ListItemButton";
import { FaBed } from "react-icons/fa";
import { FaBedPulse } from "react-icons/fa6";
import {
  MdOutlineBathroom,
  MdOutlineBedroomParent,
  MdOutlineViewModule,
} from "react-icons/md";
import { SlDirections } from "react-icons/sl";
import { IoPeopleSharp } from "react-icons/io5";
import { BsPeopleFill } from "react-icons/bs";

const RoomDetails = ({ data, open, setOpen }) => {
  const toggleDrawer = (inOpen) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setOpen(inOpen);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <Button variant="outlined" color="neutral" onClick={toggleDrawer(true)}>
        Open drawer
      </Button>
      <Drawer
        anchor="right"
        size="sm"
        open={open}
        onClose={toggleDrawer(false)}
      >
        <Box
          role="presentation"
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
        >
          <div className="p-4">
            <div className="p-3">
              <div>
                <p className="py-1 font-bold text-xl text-[#2155ad] capitalize bg-gradient-to-t from-blue-500 to-blue-900 bg-clip-text text-transparent">
                  Room Basic Information
                </p>
              </div>
              <div className=" rounded-lg flex flex-wrap justify-start items-center gap-3">
                <div className="flex justify-start items-center gap-1 text-sm text-black/50">
                  <FaBed /> <p>Bed Size: {data.bedSize}</p>
                </div>
                <div className="flex justify-start items-center gap-1 text-sm text-black/50">
                  <FaBedPulse /> <p>Beds: {data.beds}</p>
                </div>
                <div className="flex justify-start items-center gap-1 text-sm text-black/50">
                  <MdOutlineBedroomParent />{" "}
                  <p>Room Size: {data.roomSize}/sqf</p>
                </div>
                <div className="flex justify-start items-center gap-1 text-sm text-black/50">
                  <MdOutlineBathroom /> <p>Bathrooms: {data.bathrooms}</p>
                </div>
                <div className="flex justify-start items-center gap-1 text-sm text-black/50">
                  <MdOutlineViewModule /> <p>Room View: {data.roomView}</p>
                </div>
                <div className="flex justify-start items-center gap-1 text-sm text-black/50">
                  <SlDirections /> <p>Room Direction: {data.roomDirection}</p>
                </div>
                <div className="flex justify-start items-center gap-1 text-sm text-black/50">
                  <SlDirections /> <p>Room Direction: {data.roomDirection}</p>
                </div>
                <div className="flex justify-start items-center gap-1 text-sm text-black/50">
                  <IoPeopleSharp />{" "}
                  <p>Maximum Capacity: {data.adults + data.children}</p>
                </div>
                <div className="flex justify-start items-center gap-1 text-sm text-black/50">
                  <BsPeopleFill /> <p>Adults: {data.adults}</p>
                </div>
                <div className="flex justify-start items-center gap-1 text-sm text-black/50">
                  <BsPeopleFill /> <p>Children: {data.children}</p>
                </div>
              </div>
            </div>
            <div className="p-3 rounded-lg">
              <div>
                <p className="py-1 font-bold text-xl text-[#2155ad] capitalize bg-gradient-to-t from-blue-500 to-blue-900 bg-clip-text text-transparent">
                  Facilities
                </p>
              </div>
              <div className="py-3">
                {data?.facilities.map((data, index) => {
                  return (
                    <div key={index}>
                      <div className="space-y-1 pb-2">
                        <div>
                          <p className="text-sm font-bold">{data.useFor}</p>
                        </div>
                        <div className="flex justify-start items-center gap-5 flex-wrap">
                          {data.facilities.map((data, index) => {
                            return (
                              <div
                                key={index}
                                className="flex justify-start items-center gap-1"
                              >
                                <div className="w-5 h-5 overflow-hidden">
                                  <img
                                    className="w-full h-full object-cover"
                                    src={data.icon}
                                    alt=""
                                  />
                                </div>
                                <div>
                                  <p className="text-xs">{data.facilityName}</p>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </Box>
      </Drawer>
    </Box>
  );
};

export default RoomDetails;
